import type { $Fetch } from 'ofetch';
import type { WebhookSubscription, WebhookSubscriptionCommand } from '@/domain/model/Webhook';
import type { Page } from '@/domain/model/Page';
import type { WebhookSubscriptionGateway } from '@/application/port/out/WebhookSubscriptionGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/webhooks/subscriptions';

export class HttpWebhookSubscriptionGateway implements WebhookSubscriptionGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { ativo?: boolean; page?: number; size?: number }): Promise<Page<WebhookSubscription>> {
    const params: Record<string, string | number | boolean> = {};
    if (typeof p.ativo === 'boolean') params['ativo'] = p.ativo;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<WebhookSubscription>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<WebhookSubscription> {
    const res = await this.client<ApiResponse<WebhookSubscription>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async criar(command: WebhookSubscriptionCommand): Promise<WebhookSubscription> {
    const res = await this.client<ApiResponse<WebhookSubscription>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async atualizar(id: string, command: WebhookSubscriptionCommand): Promise<WebhookSubscription> {
    const res = await this.client<ApiResponse<WebhookSubscription>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async desativar(id: string): Promise<void> {
    await this.client<null>(`${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
